import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../../components/Common/TextInput';
import CallOut from '../../../components/Common/CallOut';
import Notification from '../../../components/Common/Notification';
import ActivityLoader from '../../../components/Common/ActivityLoader';
import { useTheme } from '../../../DataStore/ThemeContext';
import { useConfig } from '../../../DataStore/ConfigContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    username: '',
    role: '',
    loading: false,
}

const NewUserInvite = () => {

    const {setNotify} = useTheme();

    const [info, setInfo] = useState(null);
    const {getUserRoles, getUsers, userRoles} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        getUserRoles();
    }, [])

    useEffect(()=>{
        if(info){
            setTimeout(() => {
                setInfo(null);
            }, 5000);
        }
    }, [info]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(!state.role.value){
            setInfo(<Notification type='danger' message="Select user role, then try again"/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.inviteUser({'role_id':state.role.value, 'username': state.username});
        console.log(server_response);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setInfo(<Notification type='success' message={server_response.message}/>);
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'RESET'});

            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            setTimeout(() => {
                getUsers(true);
            }, 2000);
           
        }else{
            setInfo(<Notification type='danger' message={server_response.message}/>);

        }

    }




    const RenderRole = () => {
        const options = [];
         Array.isArray(userRoles) && userRoles.map((item) =>
                options.push({ label: item.role_name, value: item.role_id })
            );
        

        return (
            <TextInput
                label="User Role"
                type="select"
                leftIcon={true}
                placeholder={state.role.label || 'Select user role....'}
                options={options}
                onChange={(item) => dispatch({ type: 'role', value: item })}
                leftComponent={<i className="fa fa-user-tag link" onClick={getUserRoles}></i>}
                loading={!userRoles}
                wrap
            />
        );
    };

    return (
        <div className="card-body">

            <CallOut 
                title="System Users"
                description="Invite an existing eSchool user by specifying their username/email and role. The user is automatically added with system access unless deactivated or deleted"
             />
            {info}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Username or Email"
                            placeholder="Username or Email"
                            leftIcon="fa fa-envelope"
                            value={state.username}
                            onChange={e => dispatch({type: 'username', value: e.target.value})}
                            required
                            wrap
                            />

                            <RenderRole />

                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-success">Invite & Add</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 

        </div>
    );
};

export default NewUserInvite;